import { Pencil, Trash2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";
import { Switch } from "../ui/switch";
import { inputCls, Field } from "./adminConstants";

export function CatalogView({ ctx }) {
  const {
    cartEnabled, toggleCart, products, openEdit, remove,
    dialogOpen, setDialogOpen, editing, form, setForm, save, saving,
  } = ctx;

  return (
    <>
      <div className="px-6 lg:px-12 pt-6">
        <div
          className="flex items-center justify-between border border-white/20 bg-[#141A14] px-6 py-5"
          data-testid="cart-toggle-bar"
        >
          <div>
            <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-[#D47738] mb-1">
              E-commerce
            </p>
            <p className="font-serif-display text-2xl text-[#E8E2D2]">
              Carrello {cartEnabled ? "attivo" : "disattivato"}
            </p>
            <p className="text-sm text-[#E8E2D2]/50 mt-1">
              {cartEnabled
                ? "I clienti possono aggiungere birre al carrello e pagare online."
                : "Il sito mostra il catalogo ma la vendita online è disabilitata."}
            </p>
          </div>
          <Switch
            checked={cartEnabled}
            onCheckedChange={toggleCart}
            className="data-[state=checked]:bg-[#D47738]"
            data-testid="cart-toggle-switch"
          />
        </div>
      </div>

      <div className="p-6 lg:p-12">
        <div className="border border-white/20 overflow-x-auto">
          <table className="w-full text-left" data-testid="products-table">
            <thead>
              <tr className="border-b border-white/20 font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40">
                <th className="px-4 py-4">Immagine</th>
                <th className="px-4 py-4">Nome</th>
                <th className="px-4 py-4 hidden md:table-cell">Stile</th>
                <th className="px-4 py-4 hidden md:table-cell">ABV</th>
                <th className="px-4 py-4">Prezzo</th>
                <th className="px-4 py-4 hidden md:table-cell">Stock</th>
                <th className="px-4 py-4 text-right">Azioni</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p) => (
                <tr key={p.id} className="border-b border-white/10" data-testid={`admin-row-${p.id}`}>
                  <td className="px-4 py-3">
                    <img src={p.image} alt={p.name} className="w-12 h-14 object-cover bg-[#141A14]" />
                  </td>
                  <td className="px-4 py-3 font-serif-display text-xl">
                    <span className="inline-flex items-center gap-2">
                      {p.name}
                      {p.stock <= 0 && (
                        <span className="font-mono-accent text-[9px] uppercase tracking-widest px-2 py-1 bg-[#9E3C3C]/25 text-[#9E3C3C] border border-[#9E3C3C]/50" data-testid={`sold-out-badge-${p.id}`}>
                          Esaurito
                        </span>
                      )}
                    </span>
                  </td>
                  <td className="px-4 py-3 hidden md:table-cell font-mono-accent text-xs text-[#E8E2D2]/60">{p.style}</td>
                  <td className="px-4 py-3 hidden md:table-cell font-mono-accent text-xs text-[#D47738]">{p.abv}%</td>
                  <td className="px-4 py-3 font-mono-accent text-sm">€ {p.price.toFixed(2)}</td>
                  <td className="px-4 py-3 hidden md:table-cell font-mono-accent text-xs">
                    {p.stock <= 0 ? (
                      <span className="text-[#9E3C3C] uppercase tracking-widest">Esaurito</span>
                    ) : (
                      p.stock
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex items-center justify-end gap-2">
                      <button onClick={() => openEdit(p)} className="p-2 border border-white/20 hover:border-[#D47738] hover:text-[#D47738] transition-colors" data-testid={`edit-${p.id}`}>
                        <Pencil className="w-3.5 h-3.5" />
                      </button>
                      <button onClick={() => remove(p)} className="p-2 border border-white/20 hover:border-[#9E3C3C] hover:text-[#9E3C3C] transition-colors" data-testid={`delete-${p.id}`}>
                        <Trash2 className="w-3.5 h-3.5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent className="bg-[#141A14] border border-white/20 text-[#E8E2D2] max-w-lg max-h-[90vh] overflow-y-auto" data-testid="product-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif-display text-3xl text-[#E8E2D2]">
              {editing ? "Modifica Birra" : "Nuova Birra"}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-3 py-2">
            <Field label="Nome" v={form.name} on={(x) => setForm({ ...form, name: x })} tid="f-name" />
            <Field label="Stile" v={form.style} on={(x) => setForm({ ...form, style: x })} tid="f-style" />
            <div>
              <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Descrizione</label>
              <textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className={inputCls + " mt-1 resize-none"} rows={3} data-testid="f-description" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <Field label="ABV %" type="number" v={form.abv} on={(x) => setForm({ ...form, abv: x })} tid="f-abv" />
              <Field label="IBU" type="number" v={form.ibu} on={(x) => setForm({ ...form, ibu: x })} tid="f-ibu" />
              <Field label="Volume" v={form.volume} on={(x) => setForm({ ...form, volume: x })} tid="f-volume" />
              <Field label="Prezzo €" type="number" v={form.price} on={(x) => setForm({ ...form, price: x })} tid="f-price" />
              <Field label="Stock" type="number" v={form.stock} on={(x) => setForm({ ...form, stock: x })} tid="f-stock" />
            </div>
            <Field label="Prezzo di riferimento € (barrato, opzionale — lascia vuoto per non mostrarlo)" type="number" v={form.compare_at_price} on={(x) => setForm({ ...form, compare_at_price: x })} tid="f-compare-price" />
            <Field label="URL Immagine principale" v={form.image} on={(x) => setForm({ ...form, image: x })} tid="f-image" />
            <Field label="Galleria (URL separati da virgola)" v={form.images} on={(x) => setForm({ ...form, images: x })} tid="f-images" />
            <Field label="Immagine hover (mano che afferra la lattina)" v={form.condensation_image} on={(x) => setForm({ ...form, condensation_image: x })} tid="f-condensation" />
            <Field label="Abbinamenti (separati da virgola)" v={form.food_pairings} on={(x) => setForm({ ...form, food_pairings: x })} tid="f-pairings" />
            <div>
              <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Storia della ricetta</label>
              <textarea value={form.recipe_story} onChange={(e) => setForm({ ...form, recipe_story: e.target.value })} className={inputCls + " mt-1 resize-none"} rows={4} data-testid="f-story" />
            </div>
          </div>
          <DialogFooter>
            <button onClick={() => setDialogOpen(false)} className="px-6 py-3 border border-white/20 font-mono-accent text-xs uppercase tracking-widest hover:border-white/50 transition-colors">
              Annulla
            </button>
            <button onClick={save} disabled={saving} className="px-6 py-3 bg-[#D47738] text-[#0D110D] font-mono-accent text-xs uppercase tracking-widest hover:bg-[#E8E2D2] transition-colors disabled:opacity-50" data-testid="save-product-btn">
              {saving ? "Salvataggio..." : "Salva"}
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
